import type { MantineTheme } from '@mantine/core';

type ColorScheme = 'light' | 'dark';

export const UNREAD_INDICATOR_SIZE = 16;

export const getUnreadIndicatorColor = (
  theme: MantineTheme,
  colorScheme: ColorScheme
): string => theme.colors[`red-${colorScheme}`][0];

export const formatUnreadCount = (unreadCount: number): number | string =>
  unreadCount > 99 ? '99+' : unreadCount;
